const DEFAULT_PRODUCTION_BACKEND_URL = "https://cphere-backend.onrender.com";

function normalizeBase(value) {
  return String(value || "").trim().replace(/\/+$/, "");
}

const API_BASE_URL = normalizeBase(
  process.env.REACT_APP_BACKEND_URL ||
    (process.env.NODE_ENV === "production" ? DEFAULT_PRODUCTION_BACKEND_URL : "")
);

function getAuthToken() {
  try {
    return (
      localStorage.getItem("superadminToken") ||
      localStorage.getItem("clientAuthToken") ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("token") ||
      localStorage.getItem("accessToken") ||
      ""
    );
  } catch {
    return "";
  }
}

function apiUrl(path) {
  const normalizedPath = String(path || "").startsWith("/") ? path : `/${path}`;
  if (API_BASE_URL) return `${API_BASE_URL}${normalizedPath}`;
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${normalizedPath}`;
  }
  return normalizedPath;
}

export async function getLiveMetaAdsLibrary({
  advertiserId,
  platform,
  datePreset = "maximum",
  campaignKey = "all",
  since = null,
  until = null,
  refresh = false,
  signal,
} = {}) {
  const query = new URLSearchParams({
    advertiserId: String(advertiserId || ""),
    platform: String(platform || ""),
    datePreset: String(datePreset || "maximum"),
    campaignKey: String(campaignKey || "all"),
  });
  if (since) query.set("since", since);
  if (until) query.set("until", until);
  if (refresh) {
    query.set("refresh", "1");
    query.set("ts", String(Date.now()));
  }

  const token = getAuthToken();
  const response = await fetch(apiUrl(`/api/meta/live-ads?${query.toString()}`), {
    method: "GET",
    signal,
    cache: "no-store",
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  const text = await response.text().catch(() => "");
  let body = null;
  try {
    body = text ? JSON.parse(text) : null;
  } catch {
    body = null;
  }
  if (!response.ok) {
    const error = new Error(body?.message || "Live Meta reporting is unavailable.");
    error.code = body?.error || "META_TEMPORARY_FAILURE";
    error.status = response.status;
    throw error;
  }
  return body;
}

export const metaAdsLibraryServiceContract = Object.freeze({
  endpoint: "/api/meta/live-ads",
  version: "meta_live_ads_library_v3",
  platforms: Object.freeze(["facebook", "instagram"]),
});
